import { faMessage } from '@fortawesome/pro-solid-svg-icons';

import { Tag } from '@growtherapy/sprout-ui';

import { IconMenuItem } from '../../components';
import { PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';

export function ChatDrawerControlMenuItem({
  isChatDrawerOpen,
  onClick,
  unreadMessageCount,
}: {
  isChatDrawerOpen: boolean;
  isChatButtonDisabled: boolean;
  onClick: () => void;
  unreadMessageCount: number;
}) {
  return (
    <IconMenuItem
      aria-controls={PUSH_DRAWER_ARIA_CONTROLS_ID}
      aria-expanded={isChatDrawerOpen}
      className='flex items-center gap-2'
      onClick={onClick}
      icon={faMessage}
    >
      <span className='sr-only'>{isChatDrawerOpen ? 'Close' : 'Open'} chat,</span>
      <span aria-hidden>Chat</span>
      {unreadMessageCount ? <Tag use='lilac'>{unreadMessageCount}</Tag> : <span className='sr-only'>0</span>}
      <span className='sr-only'>unread {unreadMessageCount === 1 ? 'message' : 'messages'}</span>
    </IconMenuItem>
  );
}
